import { Form, Input, Rate, type FormProps } from 'antd'
import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import textMaximumLength from '@/constants/text-maximum-length'
import { useIntl } from '@/i18n/hooks/use-intl'
import {
  draftScoringSchema,
  type DraftScoring,
} from '@/types/schema/directory/collaboration-record'

const ScoringForm: FunctionComponent<
  Omit<FormProps<DraftScoring>, 'layout'>
> = ({ form, preserve = false, ...props }) => {
  const { formatMessage } = useIntl()

  return (
    <Form form={form} layout='vertical' preserve={preserve} {...props}>
      <FormItem
        label={formatMessage({
          id: 'kol_cooperation_detail_drawer:tabs_cooperation_history',
        })}
        name={draftScoringSchema.keyof().enum.evaluation_score}
        rules={[
          {
            required: true,
            message: formatMessage(
              { id: 'error:please_select' },
              {
                selectField: formatMessage({
                  id: 'kol_cooperation_detail_drawer:tabs_cooperation_history',
                }),
              },
            ),
          },
        ]}
      >
        <Rate allowHalf />
      </FormItem>
      <FormItem
        initialValue={props.initialValues?.evaluation_content ?? ''}
        name={draftScoringSchema.keyof().enum.evaluation_content}
        rules={[
          {
            max: textMaximumLength.title,
            message: formatMessage({ id: 'error:please_select' }),
          },
        ]}
      >
        <Input.TextArea
          placeholder={formatMessage({
            id: 'kol:edit_coop_field_content_placeholder',
          })}
          rows={4}
        />
      </FormItem>
    </Form>
  )
}

const FormItem = styled(Form.Item)`
  margin-bottom: 12px;
`

export default ScoringForm
